<script lang="ts" setup>
import { ButtonComp } from '@/components';
import { computed } from 'vue';
import { ref } from 'vue';

const props = defineProps<{
    modelValue: Date;
}>();

const emits = defineEmits(['update:modelValue']);

const displayYear = ref(new Date(props.modelValue));

const years = computed(() =>
    Array.from({ length: 25 }, (x, i) => {
        return i + displayYear.value.getFullYear() - 12;
    }),
);

const changeYear = (delta: number) => {
    const d = new Date(displayYear.value);
    d.setFullYear(d.getFullYear() + delta);
    displayYear.value = d;
};
</script>

<template>
    <div class="d-flex justify-content-between">
        <ButtonComp
            button-type="Secondary"
            icon="fa-arrow-left"
            @click="changeYear(-10)"
        />
        <ButtonComp
            button-type="Secondary"
            icon="fa-arrow-right"
            @click="changeYear(10)"
        />
    </div>
    <div class="dateinput-grid grid-years">
        <ButtonComp
            button-type="Secondary"
            v-for="year in years"
            :key="year"
            class="text-center p-1"
            @click="
                displayYear.setFullYear(year);
                emits('update:modelValue', displayYear);
            "
        >
            {{ year }}
        </ButtonComp>
    </div>
</template>
